import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Row, Col, Modal, Input, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {replace} from '../../core/extract'
import {max} from '../../core/mathz'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import Rating from '../../core/components/Rating'
import Icon from '../../core/components/Icon'
import {AnswerAction} from '../models'
import {ANSWER_ACTION_UPDATED, sendAnswerAction, updateAnswerAction, loadAnswerStream} from '../actions'
import i18n from '../i18n'
import style from './AnswerModal.less'

function questionAggregator(question) {
    return {question}
}

function answerAggregator(result, answer) {
    const aggrega = result.find((a) => a.question.uid == answer.questionUid)

    if (aggrega) {
        aggrega.answer = answer
    } else {
        console && console.warn('Question ' + answer.questionUid + ' doesn\'t exist')
    }
    return result
}

class AnswerModal extends Component {
    static propTypes = {
        ticket: PropTypes.object.isRequired,
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            aggregation: []
        }
    }

    componentWillMount() {
        // data already loaded by SatisfactionButton
        const {dispatch, campaign, stream, ticket} = this.props
        const answer = stream[0]

        const answerRate = campaign && campaign.stats.answersNumber / campaign.stats.ticketsNumberOnCampaignPeriod
        const maxScore = campaign && max({source: campaign.notationScale, identify: (s) => s.position})
        const questionAggregation = campaign && campaign.questions.map(questionAggregator).reverse() || []
        const aggregation = answer && answer.answers.reduce(answerAggregator, questionAggregation) || questionAggregation
        this.setState({answerRate, maxScore, aggregation})

        dispatch(updateAnswerAction({ticketUid: ticket.uid, answers: aggregation.map(() => null)}))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.campaign != this.props.campaign
            || nextProps.stream != this.props.stream) {
            const {dispatch, campaign, stream} = nextProps
            const answer = stream[0]

            const answerRate = campaign && campaign.stats.answersNumber / campaign.stats.ticketsNumberOnCampaignPeriod
            const maxScore = campaign && max({source: campaign.notationScale, identify: (s) => s.position})
            const questionAggregation = campaign && campaign.questions.map(questionAggregator).reverse() || []
            const aggregation = answer && answer.answers.reduce(answerAggregator, questionAggregation) || questionAggregation
            this.setState({answerRate, maxScore, aggregation})

            dispatch(updateAnswerAction({answers: aggregation.map(() => null)}))
        }

        if (nextProps.ticket != this.props.ticket) {
            const {dispatch, ticket} = nextProps
            dispatch(updateAnswerAction({ticketUid: ticket.uid, answers: null}))
        }
    }

    _sendAction() {
        const {dispatch, onHide} = this.props

        return dispatch(sendAnswerAction()).then(() => {
            return dispatch(loadAnswerStream())
        }).then(() => {
            onHide()
        })
    }

    _openComment(event, openedComment) {
        event.preventDefault()
        this.setState({openedComment})
    }

    _navigate(event, path) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(push(path))
    }

    render() {
        const {dispatch, form, action, stream, campaign, ticket, onHide, ...others} = this.props
        const {answerRate, maxScore, aggregation, openedComment} = this.state
        
        const answer = stream[0]

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const scoreField = (field, questionUid, questionIndex) => {
            const value = field.value && field.value[questionIndex] && field.value[questionIndex].score

            function onChange(score) {
                const nextValue = field.value && [...field.value] || []
                nextValue[questionIndex] = {...nextValue[questionIndex], questionUid, score}
                field.onChange(nextValue)
            }

            return {value, onChange}
        }

        const commentField = (field, questionUid, questionIndex) => {
            const value = field.value && field.value[questionIndex] && field.value[questionIndex].comment

            function onChange(event) {
                const comment = event.target.value || null

                const nextValue = field.value && [...field.value] || []
                nextValue[questionIndex] = {...nextValue[questionIndex], questionUid, comment}
                field.onChange(nextValue)
            }

            return {value, onChange}
        }

        return (
            <Modal
                bsSize='large'
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>
                        <a
                            href=''
                            onClick={(e) => this._navigate(e, '/organisations/' + ticket.linkedEntities.clientCompany.uid + '/satisfactioncampaigns/' + campaign.uid)}>
                            {campaign && campaign.title}
                        </a>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={8}>
                            <ul className={style.questionGroup}>
                                {aggregation.map((aggrega, aggregaIndex) => (
                                    <li
                                        key={aggrega.question.uid}>
                                        <h4>{aggrega.question.text}</h4>
                                        {aggrega.answer && (
                                            <div>
                                                <Rating
                                                    label={i18n.score}
                                                    range={maxScore}
                                                    value={aggrega.answer.score} />
                                                {aggrega.answer.comment && (
                                                    <p>
                                                        <Icon icon='quote' size='xs' />
                                                        <span>{aggrega.answer.comment}</span>
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                        {!aggrega.answer && (
                                            <div>
                                                <Rating
                                                    label={i18n.score}
                                                    range={maxScore}
                                                    {...scoreField(form.answers(), aggrega.question.uid, aggregaIndex)} />
                                                {(openedComment == aggregaIndex || (action && action.answers && action.answers[aggregaIndex] && action.answers[aggregaIndex].comment)) && (
                                                    <form>
                                                        <Input
                                                            type='textarea'
                                                            placeholder={i18n.comment}
                                                            {...commentField(form.answers(), aggrega.question.uid, aggregaIndex)} />
                                                    </form>
                                                )}
                                                {!(openedComment == aggregaIndex || (action && action.answers && action.answers[aggregaIndex] && action.answers[aggregaIndex].comment)) && (
                                                    <div className={style.action}>
                                                        <a
                                                            href=''
                                                            onClick={(e) => this._openComment(e, aggregaIndex)}>
                                                            <Icon icon='plus' size='xs' />
                                                            <span>{i18n.commentz}</span>
                                                        </a>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </li>
                                ))}
                            </ul>
                            {answer && answer.comment && (
                                <div className={style.globalComment}>
                                    <h4>{i18n.globalComment}</h4>
                                    <p>
                                        <Icon icon='quote' size='xs' />
                                        <span>{answer.comment}</span>
                                    </p>
                                </div>
                            )}
                            {!answer && (
                                <div className={style.globalComment}>
                                    <h4>{i18n.globalComment}</h4>
                                    <Input
                                        type='textarea'
                                        placeholder={i18n.comment}
                                        {...form.comment()} />
                                </div>    
                            )}
                            <ButtonToolbar>
                                {!answer && (
                                    <LoaderButton
                                        bsStyle='primary'
                                        bsSize='large'
                                        className={cx({disabled: !form.isValid()})}
                                        onClick={() => form.validate() && this._sendAction() || dispatch(errorStatus(i18n.formInvalid))}>
                                        {i18n.save}
                                    </LoaderButton>
                                )}
                                <Button
                                    bsSize='large'
                                    onClick={onHide}>
                                    {i18n.close}
                                </Button>
                            </ButtonToolbar>
                        </Col>
                        <Col sm={4}>
                            {campaign && (
                                <div>
                                    <div className={style.averageScore}>
                                        <h4>{i18n.averageScore}</h4>
                                        <span className={style.score}>{Math.round(campaign.stats.averageNote * 10) / 10}</span>
                                    </div>
                                    <div className={cx(style.answerCount, {[style.danger]: answerRate < campaign.answersRateGoal})}>
                                        <h4>{i18n.answerCount}</h4>
                                        <span className={style.count}>{campaign.stats.answersNumber}</span>
                                        <p>{replace(i18n.outOfEligibleTicketCount, {ticketCount: campaign.stats.ticketsNumberOnCampaignPeriod})}</p>
                                    </div>
                                    <div className={cx(style.answerRate, {[style.danger]: answerRate < campaign.answersRateGoal})}>
                                        <h4>{i18n.answerRate}</h4>
                                        <span className={style.rate}>{Math.round(answerRate * 100)}%</span>
                                        {campaign.answersRateGoal && (
                                            <p>{replace(i18n.forAnswerGoal, {answerGoal: Math.round(campaign.answersRateGoal * 100)})}</p>
                                        )}
                                    </div>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }
}

AnswerModal = connectForm({
    target: 'action',
    schema: AnswerAction.schema,
    action: ANSWER_ACTION_UPDATED
})(AnswerModal)

AnswerModal = connect((state) => ({
    stream: state.satisfaction.answer.stream,
    campaign: state.satisfaction.campaign.campaign,
    action: state.satisfaction.answerAction
}))(AnswerModal)

export default AnswerModal


// WEBPACK FOOTER //
// ./lib/satisfaction/components/AnswerModal.js